import request from '../utils/request';

// 获取字典数据
export const dicData = () => request('/common/dic-data');
// 其他
export const dicDatap = () => request('/common/dic-data');

export const ocrWaybillByPkId = (id) => request({
  url: '/admin/common/ocrByWaybillById?id=' + id,
  method: 'get',
});
